import {
  faCheck,
  faPrint,
  faTriangleExclamation
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import { cn } from "~/lib/utils";
import { usePrinterStatus } from "~/providers/app";

type TicketValidationReceiptPrintingProps = {
  onRetry: () => void;
  variant?: "light" | "dark";
};

export const TicketValidationReceiptPrinting = ({
  onRetry,
  variant = "light"
}: TicketValidationReceiptPrintingProps) => {
  const printerStatus = usePrinterStatus();

  const isLight = variant === "light";
  const textCn = cn(
    "flex items-center justify-center gap-2",
    isLight ? "text-white/80" : "text-interface-neutral-6"
  );

  if (printerStatus === "success") {
    return (
      <div className={textCn}>
        <FontAwesomeIcon icon={faCheck} />
        <span className="text-base">
          <T _str="Receipt Printed" />
        </span>
      </div>
    );
  }

  if (printerStatus === "error") {
    return (
      <div className="flex flex-col items-center gap-3">
        <div
          className={cn(
            "flex items-center gap-2",
            isLight ? "text-white/80" : "text-interface-neutral-6"
          )}
        >
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <span className="text-base">
            <T _str="Receipt printing failed" />
          </span>
        </div>
        <Button
          variant={isLight ? "primary-light" : "secondary"}
          icon={faPrint}
          onClick={onRetry}
        >
          <T _str="Retry" />
        </Button>
      </div>
    );
  }

  return (
    <div className={textCn}>
      <FontAwesomeIcon icon={faPrint} />
      <span className="text-base">
        <T _str="Printing Receipt..." />
      </span>
    </div>
  );
};
